"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormElementChildTypeExposedEnum = void 0;
var FormElementChildTypeExposedEnum;
(function (FormElementChildTypeExposedEnum) {
    FormElementChildTypeExposedEnum["INPUT"] = "input";
    FormElementChildTypeExposedEnum["NUMBER"] = "number";
    FormElementChildTypeExposedEnum["EMAIL"] = "email";
    FormElementChildTypeExposedEnum["PHONE"] = "phone";
})(FormElementChildTypeExposedEnum = exports.FormElementChildTypeExposedEnum || (exports.FormElementChildTypeExposedEnum = {}));
